// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-bingmaps{\r\n\twidth: 100%;\r\n\theight: 100%\r\n}", ""]);
// Exports
module.exports = exports;
